import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Box from '@mui/material/Box';
import { Suspense, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { useAuthentication } from './common/hooks/authentication';
import ErrorHandler from './components/errorHandling/ErrorHandler';
import Loading from './components/molecules/Loading';
import TopMenu from './components/topMenu/TopMenu';
import { useAppSelector } from './redux/store';
var Page = function () {
    var token = useAppSelector(function (store) { return store.auth.token; });
    return (_jsx(Box, { children: token ? (_jsxs(_Fragment, { children: [_jsx(TopMenu, {}), _jsx(ErrorHandler, { children: _jsx(Suspense, { children: _jsx(Outlet, {}) }) })] })) : (_jsx(Loading, { sx: { height: '100vh', width: '100%' } })) }));
};
var Component = withAuthenticationRequired(Page);
export var BasePage = function () {
    var tenant = useAuthentication().tenant;
    var token = useAppSelector(function (store) { return store.auth.token; });
    var navigate = useNavigate();
    var defaultLink = "/tenants/".concat(tenant);
    useEffect(function () {
        if (token) {
            if (window.location.pathname === '/') {
                navigate(defaultLink);
            }
        }
    }, [navigate, token, defaultLink]);
    return _jsx(Component, {});
};
